import React from 'react';

export default function Button({ className = '', children, ...props }) {
  return (
    <button
      className={
        'inline-flex items-center justify-center rounded-xl px-4 py-2 text-sm font-semibold ' +
        'bg-slate-800 text-slate-50 border border-slate-700 shadow-sm ' +
        'hover:bg-slate-700 hover:border-emerald-400 transition ' +
        'focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 focus:ring-offset-slate-950 ' +
        'disabled:opacity-60 disabled:cursor-not-allowed ' +
        className
      }
      {...props}
    >
      {children}
    </button>
  );
}
